import { push } from "connected-react-router";
import React from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { Button } from "../../components/RegularComponents";
import { setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";;

const MORTGAGE_APPLICATION_PROPERTY = "complianceOfficer";
// const applicationType = APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE;
// const applicationMode = APPLICATION_MODE_NEW;

export const ComplianceOfficer = (props) => {
  const dispatch = useDispatch();

  //const [applicationSaveError, setApplicationSaveError] = useState(false);


  const handleNext = (complianceOfficer) => () => {
    dispatch(
      setMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: complianceOfficer,
      })
    );

    // dispatch(saveBusinessLicenceApplicationData(
    //   applicationType, applicationMode))
    //   .then(data => {
    //     const nextPath = complianceOfficer
    //         ? ROUTE_PATH.ML_HAS_ROLE_WITH_RJSC
    //         : ROUTE_PATH.ML_IS_COMPLIANCE_OFFICER_NO;
    //       dispatch(push(`${ROUTE_PATH.ML_APP}${nextPath}`));
    //   })
    //   .catch(err => {
    //     //setApplicationSaveError(true)
    //   })

    const nextPath = complianceOfficer
        ? ROUTE_PATH.ML_HAS_ROLE_WITH_RJSC
        : ROUTE_PATH.ML_IS_COMPLIANCE_OFFICER_NO;
      dispatch(push(`${ROUTE_PATH.ML_APP}${nextPath}`));
    
  };

  return (
    <div className="container">
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>
           Compliance Officer
          </h1>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <p>
            Before you apply, your company needs to identify a compliance officer. The compliance officer must be a director, partner, officer, or sole proprietor at the company.
          </p>
          <p>
            The compliance officer needs to complete this application for the company's lender licence and handle all licensing responsibilities on behalf of the company.
          </p>
          <p>
            Are you the compliance officer for your company?
          </p>
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2">
          <Button
            className="ns-btn-yes-no"
            buttonType="regular_primary"
            onClick={handleNext(true)}
            text="Yes"
          />
        </div>

        <div className="col-lg-2">
            <Button
              className="ns-btn-yes-no"
              buttonType="regular_primary"
              onClick={handleNext(false)}
              value={false}
              text="No"
            />
          </div>
      </div>
    </div>
  );
};
